<ion-nav [root]="rootPage" [rootParams]="rootParams"></ion-nav>
